import classNames from 'classnames';

import React, {
  CSSProperties,
  forwardRef,
  ForwardRefExoticComponent,
  HTMLAttributes,
  RefAttributes,
} from 'react';

import styles from './counter-animation.scss';

const DURATION = '2s';
const TIMING_FUNCTION = 'cubic-bezier(0, 0.55, 0.45, 1)';

type CounterAnimationProps = RefAttributes<HTMLSpanElement> &
  HTMLAttributes<HTMLSpanElement> & {
    value: number;
    duration?: string;
    timingFunction?: string;
    prefix?: string;
    suffix?: string;
    dataTestId?: string;
  };

export const COMPONENT_ID = 'modulor-counter-animation';

export const CounterAnimation: ForwardRefExoticComponent<CounterAnimationProps> = forwardRef<
  HTMLSpanElement,
  CounterAnimationProps
>(
  (
    {
      value,
      duration = DURATION,
      timingFunction = TIMING_FUNCTION,
      prefix,
      suffix,
      dataTestId = COMPONENT_ID,
      className,
      ...rest
    },
    ref,
  ) => (
    <span
      ref={ref}
      data-testid={dataTestId}
      data-component-name={COMPONENT_ID}
      data-id={dataTestId}
      className={classNames(styles.container, className)}
      style={
        {
          '--duration': duration,
          '--timing-function': timingFunction,
        } as CSSProperties
      }
      {...rest}>
      {prefix && <span data-testid={`${dataTestId}-prefix`}>{prefix}</span>}
      <span
        className={styles.counter}
        data-testid={`${dataTestId}-counter`}
        style={
          {
            '--num': value,
          } as CSSProperties
        }
      />
      {suffix && <span data-testid={`${dataTestId}-suffix`}>{suffix}</span>}
    </span>
  ),
);

CounterAnimation.displayName = 'CounterAnimation';
